// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Oi-z","breadcrumbItem":"Pi-z"};